import axios from 'axios'
import { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import urlSearchParams from '../../components/urlSearchParams'
import { EmployeeContext } from '../../context api/Employee/EmployeeContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { bulkUploadPopup, toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { checkCancelToken, error, ROUTES, success, getNewToken } from '../../shared/constants'

export const useCompanyAdmin = (handleNext) => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [employee, setEmployee] = useState(false)
  const [positionEmployees, setPositionEmployees] = useState([])
  const [rankedEmployees, setRankedEmployees] = useState([])
  const [done, setDone] = useState(false)
  const { getNewEmployees, addNewEmployee, editNewEmployee, deleteNewEmployee } = useContext(EmployeeContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  const [allEmployeeAboveRank6, setAllEmployeeAboveRank6] = useState(false)
  const [cancelToken, setCancelToken] = useState()
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pdfCsvData, setPdfCsvData] = useState({ headings: [], headingValues: [] })
  ////console.log('CANCEL TOKEN : ', cancelToken)

  useEffect(() => {
    if (cancelToken) {
      setLoading(true)
    }
  }, [cancelToken])


  const addEmployee = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        console.log({status})
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        history.push(ROUTES.ALL_EMPLOYEES)
        toastMessage('Employee Added Successfully', success)

      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          console.log('RESPONSE : ', err.response)
          return toastMessage(err.response.data.error ? err.response.data.error
             : err.response.data.errors && err.response.data.errors[0].message, error)
        }
      })
  }

  const updateEmployee = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Employee Updated Successfully', success)
        history.push(ROUTES.ALL_EMPLOYEES)
        getAllEmployee()

        // localStorage.setItem('employeeId', data.AllEmployee._id)
        // editNewEmployee(data.AllEmployee)

        handleNext(true)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log('RESPONSE : ', err.response)
          return toastMessage(err.response.data.error ? err.response.data.error : err.response.data.errors && err.response.data.errors[0].msg, error)
        }
      })
  }

  const getEmployeeDetailByPosition = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ALL_EMPLOYEE_BY_POSITION, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPositionEmployees(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getEmployeeByRank = (dto) => {
    setLoading(true)
    axios
      .post(API.GET_ALL_EMPLOYEE_BY_RANK, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        console.log(data.data)
        setRankedEmployees(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getEmployee = (dto) => {
    setLoading(true)
    let emp = {};
    axios
      .post(API.GET_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        emp = data.user;
        setEmployee(data.user)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
      return emp
  }

  const deleteEmployee = (dto) => {
    setLoading(true)
    axios
      .post(API.DELETE_EMPLOYEE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Employee Deleted Successfully', success)
        deleteNewEmployee(dto.employeeId)

        // handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }


  const getAllEmployee = (dto = {}) => {
    axios
      .get(API.GET_ALL_EMPLOYEE(urlSearchParams(dto)), {
        ...header,
        cancelToken: getNewToken(cancelToken, setCancelToken),
      })
      .then(({ status, data }) => {
        setLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewEmployees(data.USR ? data.USR : [], data.totalPage)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const updateCompanyAdmin = (dto) => {
    setLoading(true)
    axios
      .put(API.UPDATE_COMPANY_ADMIN, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Profile Updated Successfully', success)
        // localStorage.setItem('employeeId', data.AllEmployee._id)
        // editNewEmployee(data.AllEmployee)

        // handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const updateCompanyAdminSetting = (dto) => {
    setLoading(true)
    axios
      .put(API.UPDATE_COMPANY_ADMIN_SETTING, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Setting Updated Successfully', success)
        // localStorage.setItem('employeeId', data.AllEmployee._id)
        // editNewEmployee(data.AllEmployee)

        // handleNext()
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        bulkUploadPopup(data, addNewEmployee)
        getAllEmployee()
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getAllEmployeeAboveRank6 = (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_EMPLOYEE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setAllEmployeeAboveRank6(data.USR ? data.USR.filter((val) => val.rank != 6) : [])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  const getPdfCsvData = async (dto = {}) => {
    setDownloadLoading(true)
    dto = { ...dto, download: 1 }
    axios
      .get(API.GET_ALL_EMPLOYEE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setDownloadLoading(false)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPdfCsvData(data)
      })
      .catch((err) => {
        setDownloadLoading(false)
        if (err.response) {
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    addEmployee,
    employee,
    rankedEmployees,
    getEmployeeByRank,
    getAllEmployee,
    deleteEmployee,
    getEmployeeDetailByPosition,
    positionEmployees,
    updateEmployee,
    updateCompanyAdminSetting,
    updateCompanyAdmin,
    done,
    getEmployee,
    loading,
    BulkUpload,
    paginate,
    getAllEmployeeAboveRank6,
    allEmployeeAboveRank6,
    downloadLoading,
    getPdfCsvData,
    pdfCsvData,
  }
}
